import { isTruthy } from "../../../utils/types"

const splitPath = (path: string) => {
  return path.split("/").filter(isTruthy)
}

const WILDCARD = "*"

/**
 * Check if a path matches a path pattern
 * Supports wildcard matching with asterisk (*)
 */
export function pathMatchesPattern(
  pagePath: string,
  pathPattern: string,
): boolean {
  const pageSegments = splitPath(pagePath)
  const patternSegments = splitPath(pathPattern)
  const isLastPatternSegmentWildcard =
    patternSegments[patternSegments.length - 1] === WILDCARD

  if (
    !isLastPatternSegmentWildcard &&
    pageSegments.length !== patternSegments.length
  ) {
    return false
  }

  return pageSegments.every((pagePart, index) => {
    const patternPart = patternSegments[index]
    const pathSegmentExceedsPatternLength = index > patternSegments.length - 1

    if (
      patternPart === WILDCARD ||
      (pathSegmentExceedsPatternLength && isLastPatternSegmentWildcard)
    ) {
      return true
    }
    return pagePart === patternPart
  })
}
